import {ValidateState} from 'lib.common';
import {PtrnCampoEditableInt, PtrnCampoValidarResult} from '../../patronTypes';
import {PtrnTransformarCampoFn, PtrnValidarCampoFn} from './ptrnProcesarTypes';
import {PtrnProcesarUtilsCfg, PtrnProcesarValidacionesComunes} from './ptrnProcesarUtils';

export const ptrnValidarInt: PtrnValidarCampoFn<any, PtrnCampoEditableInt> = (
   currValue,
   campoConfig,
   estado
) => {
   const validateResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();
   //1. control de errores q deben evitar actualizacion del nuevo valor, x ejemplo si es numerico no deberia actualizar si el nuevo valor contiene letras
   //|---> si existe error hacer result.push(<mensaje_error>) y retornar result

   if (PtrnProcesarValidacionesComunes.esMayor(currValue, campoConfig.max)) {
      validateResult.errores.push(
         PtrnProcesarUtilsCfg.ErrValidar(`El valor no puede ser mayor a: ${campoConfig.max}`)
      );
      validateResult.gravedadMaxima = ValidateState.ERROR;
      return validateResult;
   }

   if (PtrnProcesarValidacionesComunes.esMenor(currValue, campoConfig.min)) {
      validateResult.errores.push(
         PtrnProcesarUtilsCfg.ErrValidar(`El valor no puede ser menor a: ${campoConfig.min}`)
      );
      validateResult.gravedadMaxima = ValidateState.ERROR;
      return validateResult;
   }

   return validateResult;
};

export const ptrnTranformarInt: PtrnTransformarCampoFn<any, PtrnCampoEditableInt> = (
   originalValue,
   campoConfig,
   estado
) => {
   let newValue = originalValue;

   if (typeof originalValue === 'string') {
      // Primero removemos todos los signos negativos
      let numeroLimpio = originalValue.replace(/-/g, '');
      // Luego removemos cualquier carácter que no sea dígito
      numeroLimpio = numeroLimpio.replace(/[^\d]/g, '');

      // Eliminamos ceros a la izquierda
      numeroLimpio = numeroLimpio.replace(/^0+(?!$)/, '');

      // Solo agregamos el signo negativo si:
      // - El valor original comenzaba con signo negativo
      // - Y está permitido usar negativos
      if (campoConfig.permitirNegativos && originalValue.startsWith('-')) {
         numeroLimpio = '-' + numeroLimpio;
      }

      // Si el valor se modificó o quedó vacío, actualizamos newValue
      if (numeroLimpio !== originalValue || numeroLimpio === '') {
         originalValue = numeroLimpio === '' ? '' : numeroLimpio;
      }
   }

   return newValue;
};
